import React from "react"

import Default from "../../Default"

const PrivacyPolicy = () => {
  const title = "Privacy Notice"
  const description = (
    <>
      <p>
        <strong>Resanec Pty Ltd</strong> (ABN 30 631 781 729 ) is committed to
        protecting and upholding your rights to privacy.
      </p>
      <p>
        We have adopted the Australian Privacy Principles (APPs) contained in
        the Privacy Act 1988 (Cth). The APPs govern the way in which we collect,
        use, disclose, store, secure and dispose of your Personal Information.
      </p>

      <h2>What is Personal Information and why do we collect it?</h2>
      <p>
        Personal Information is information that identifies an individual.
        Examples of Personal Information we collect include: names, addresses,
        email addresses, phone and mobile number.
      </p>
      <p>
        When we collect Personal Information we will, where appropriate and
        where possible, explain to you why we are collecting the information and
        how we plan to use it.
      </p>
      <p>This Personal Information is obtained in many ways, including:</p>
      <ul>
        <li>your interaction with our website</li>
        <li>
          your interactions with third parties - your family and friends who
          support you and who, in turn interact with our website
        </li>
        <li>
          your interactions with other third parties - Local Area Coordinators,
          Planners, Support Coordinators and Service Providers who in turn
          interact with our website
        </li>
      </ul>
      <p>
        We collect your Personal Information so we may provide our support
        planning services and to provide marketing information via email about
        products and services that you may find of value. You may unsubscribe
        from our email mailing/marketing list at any time by using the
        “Unsubscribe” option on our website.
      </p>

      <h2>Third Parties</h2>
      <p>
        Where reasonable and practicable to do so, we will collect your Personal
        Information only from you. However, in some instances information may be
        provided by third parties. In such a case we will take reasonable steps
        to ensure that you are made aware of the information provided to us by
        the third party.
      </p>

      <h2>Disclosure of Personal Information</h2>
      <p>
        Your Personal Information may be disclosed in a number of circumstances
        including the following:
      </p>
      <ul>
        <li>to third parties where you consent to disclosure; and</li>
        <li>Where required or authorised by law.</li>
      </ul>

      <h2>Security of Personal Information</h2>
      <p>
        Your Personal Information is stored in a manner that reasonably protects
        it from misuse and loss and from unauthorized access, modification or
        disclosure.
      </p>
      <p>
        When your Personal Information is no longer needed for the purpose for
        which it was obtained, we will take reasonable steps to destroy or
        permanently de-identify your Personal Information. However, most of the
        Personal Information is or will be stored in client files which will be
        kept by us for a minimum of 7 years.
      </p>

      <h2>Access to your Personal Information</h2>
      <p>
        You may access the Personal Information we hold to update and/or correct
        it.
      </p>
    </>
  )

  return <Default title={title} description={description} />
}

export default PrivacyPolicy
